import React, { FC } from 'react';
import cn from 'classnames';
import styles from './LandscapeAboutParticipantAddTemplate.module.css';
import { Button, Label } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeAboutParticipantOrganism } from '../../organisms';
import { ParticipantResponseDto } from '../../../store/landscapeAPI/participant/dto/response/participant-response.dto';
import { Container } from 'react-bootstrap';

interface LandscapeAboutParticipantAddTemplateProps {
  handleOnChange: (participant: ParticipantResponseDto) => void;
  participant: ParticipantResponseDto;
  callbackFn: (participant: ParticipantResponseDto) => void;
}

const LandscapeAboutParticipantAddTemplate: FC<
  LandscapeAboutParticipantAddTemplateProps
> = ({ handleOnChange, participant, callbackFn }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Create Participant" size="lg" />
          <Button
            className={styles.buttonLink}
            onClick={() => navigate(`/landscapes/edit/${id}/about`)}
            variant="link"
          >
            Go back to Landscape overview
          </Button>
        </div>
        <LandscapeAboutParticipantOrganism
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
          participant={participant}
        />
      </Container>
    </>
  );
};

export default LandscapeAboutParticipantAddTemplate;
